










































import { QuestionnaireGatewayModel } from '@/core/models';
import { Component, Prop } from 'vue-property-decorator';

import { ValidationMessageCpt, SelectableInputComponent, InputTextareaCpt } from '.';

@Component({
  components: {
    ValidationMessageCpt,
    InputTextareaCpt,
  },
})
export default class InputRadioGatewayCpt extends SelectableInputComponent {
  @Prop({ default: false }) showComment: boolean;
  @Prop({ default: '' }) commentProp: string;
  @Prop({ default: '' }) identifier: string;
  @Prop({ default: '' }) index: number;
  @Prop({ default: 'gateways' }) arrayProp: string;
  @Prop() gateway: QuestionnaireGatewayModel;

  get validationProp() {
    return `${this.arrayProp}[${this.index}].${this.prop}`;
  }

  get validationMessage() {
    if (!this.prop || !this.model || !this.model.modelState) {
      return '';
    }

    const messages = this.model.modelState[this.validationProp];
    if (!messages || messages.length === 0) {
      return '';
    }

    return messages[0] || '';
  }

  private onInternalChange(value: any) {
    this.onChange(value);
    if (!this.prop || !this.model || !this.model.modelState) {
      return;
    }

    this.model.modelState[this.validationProp] = null as any;
  }
}
